module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mDFziG/tc-custom/9781612433264.jpg?1695242251682",
      "alt": "This image is the cover for the book Clear Skin Detox Diet"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Clear Skin Detox Diet\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A food-focused strategy for eliminating skin problems and creating a radiant, beautiful complexion—includes recipes and shopping lists.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Transform your skin by flushing toxins and fueling your body the natural way. "), _c('i', [_vm._v("Clear Skin Detox Diet")]), _vm._v(" shows you how to achieve the youthful, radiant complexion you desire by packing your diet with sustainable, life-force building nutrition. Rather than trying to improve your skin with harsh topical treatments, this easy-to-follow program harnesses the power of delicious whole foods so you can overcome common ailments, including:"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" • Wrinkles"), _c('br'), _vm._v(" • Rashes"), _c('br'), _vm._v(" • Eczema"), _c('br'), _vm._v(" • Psoriasis"), _c('br'), _vm._v(" • Acne"), _c('br'), _vm._v(" • Rosacea"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Packed with mouthwatering recipes, helpful shopping lists, and skin-clearing menu plans, this book has everything you need to get on the path to eating for radiance. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lauren Talbot\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0